import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles.css";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { TerritoryProvider } from "./context/TerritoryContext";
import { installClientObservability } from "./lib/observability";

sessionStorage.removeItem("tolupanes:module-retry");
installClientObservability();
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter><AuthProvider><TerritoryProvider><App/></TerritoryProvider></AuthProvider></BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
